import jabraRCC from './jabra.connect.integration'
import loadAmazonConnect from './amazonConnectLoader'

/**
 * Start the application after a short delay.
 * Some CRM-systems are known to interfere with the initialization of this integration.
 */
 setTimeout(() => {
    loadAmazonConnect();
    jabraRCC();
}, 7000);